"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.padDate = padDate;
function padDate(num) {
    return num.toString().padStart(2, "0");
}
//# sourceMappingURL=padDate.js.map